export interface ClientEnableFlags {
  enable_patrefmgmt: boolean;
  enable_medinfomgmt: boolean;
  enable_patconnmgmt: boolean;
  enable_messagedirect: boolean;
  enable_schedulemgmt: boolean;
  enable_phimgmt: boolean;
  enable_idmgmt: boolean;
  enable_dobmgmt: boolean;
  // Sub-enables of enable_schedulemgmt (see AccountSettingsView's "Enable schedule management"
  // edit panel) — gate the two Schedule section columns in ProfileRowEditor independently.
  enable_manualscheduling: boolean;
  enable_touchpointscheduling: boolean;
}

export const DEFAULT_CLIENT_ENABLE_FLAGS: ClientEnableFlags = {
  enable_patrefmgmt: true,
  enable_medinfomgmt: true,
  enable_patconnmgmt: true,
  enable_messagedirect: true,
  enable_schedulemgmt: true,
  enable_phimgmt: true,
  enable_idmgmt: true,
  enable_dobmgmt: true,
  enable_manualscheduling: true,
  enable_touchpointscheduling: true,
};
